// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/login/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop{
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #fffa;
}

.desktop_back{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
}
.desktop_back_shade{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fffa;
}

.desktop_content{
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    padding: 44px 37px;
    gap: 14px;
    overflow: hidden;
}

.desktop_files{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 21px;
    max-width: 320px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/Desktop.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAgE;IAChE,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".desktop{\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background-color: #fffa;\n}\n\n.desktop_back{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"../../../../assets/login/background.png\");\n    background-size: cover;\n}\n.desktop_back_shade{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #fffa;\n}\n\n.desktop_content{\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    height: 100%;\n    padding: 44px 37px;\n    gap: 14px;\n    overflow: hidden;\n}\n\n.desktop_files{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 21px;\n    max-width: 320px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
